import { ApplicationEnvironment } from '../../entities/catalog/application.environment';
import { EnvironmentConfiguration } from './environment.configuration';

export const environmentDev = {
  locale: 'en-AU',
  production: false,
  api: '/api',
  domain: 'workbuddy.dev',
  auth: {
    local: {
      callbackUrl: 'http://{0}/callback',
    }
  },
  jms: {
    loginHref: 'https://id.workbuddy.dev',
    logoutHref: 'https://id.workbuddy.dev/logout',
    captcha: '6LfQ01oUAAAAAFfG2a8ZR509QugrxclKGsINjcKN',
    captchaSecret: '6LfQ01oUAAAAAFfjjGsSDeMfCc9ZPTAMswBcBh8y',
  },
  sentry: {
    dsn: 'https://7df8035db1df47deaa8135fe3b9f5bbf@sentry.io/295277',
    name: '',
    release: '',
    environment: ''
  },
  environment: ApplicationEnvironment.Development,
  appinsights: {
    instrumentationKey: '975abbed-a6ad-432d-bc6e-18ad756484b9'
  }
} as EnvironmentConfiguration;
